import * as React from "react";
import style from "./Toggle.module.scss";

interface ToggleProps {
  open: boolean;
  onClick: (expanded: any) => void;
}

const Toggle = (props:ToggleProps) => {
  let iconClassName = style.hamburgerIcon;
  if (props.open) {
    iconClassName += " " + style.clicked;
  }
  return (
    <div className={style.toggleContainer} onClick={props.onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" className={iconClassName} width="64" height="64" viewBox="0 0 48 48">
        <rect className={style.top} x="0" y="4" rx="4" ry="4" width="100%" height="8" />
        <rect className={style.middle} x="0" y="20" rx="4" ry="4" width="100%" height="8" />
        <rect className={style.bottom} x="0" y="36" rx="4" ry="4" width="100%" height="8" />
      </svg>
    </div>
  );
}

export default Toggle;